import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
      getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminGpsmap1042xsv = () => {
  console.log('🎯 GarminGpsmap1042xsv component loading');
  
  const product = findProductById("gpsmap-1042xsv");
  
  if (!product) {
    console.error('Product not found:', "gpsmap-1042xsv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-1042xsv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminGpsmap1042xsv; 